import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Logger } from './logger.service';



@NgModule({
  declarations: [],
  imports: [
    CommonModule
  ],
  providers: [Logger],
})
export class DevelopmentModule { }
